import { memo, cloneElement, Children } from "react";
import cn from "classnames";
import Divider from "@ui-kit/Divider/Divider";
import s from "./Slider.module.scss";

const SliderSlides = ({
  children,
  className,
  wrapClassName,
  snapAlign = "",
  currentSlide,
  scrollerRef,
  withDivider,
  dividerProps = {},
}) => {
  const childrens = Children.toArray(children);
  return (
    <div className={cn(s.wrap, wrapClassName)}>
      <div
        ref={scrollerRef}
        className={cn(s.slides, className)}
        data-current-slide={currentSlide}
      >
        {childrens.map(({ props, ...child }) =>
          cloneElement(
            { props, ...child },
            {
              style: {
                ...props.style,
                ...(snapAlign ? {
                  scrollSnapAlign: snapAlign,
                } : {}
                ),

              },
            },
          ),
        )}
      </div>
      {withDivider && <Divider {...dividerProps} />}
    </div>
  );
};

export default memo(SliderSlides);
